import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { FieldInterventionListBloc } from '@connect-services/client/blocs/field-intervention-list.bloc';
import { ManagementListHeaderComponent } from '@connect-services/client/components/management/management-list-header/management-list-header.component';
import { AbstractNotificationSelectListComponent } from '@connect-services/client/components/management/notification/abstract-notification-select-list.component';
import { ProjectService } from '@connect-services/client/services/project.service';
import { CheckboxComponent } from '@connect-services/src/lib/components/checkbox/checkbox.component';
import { PaginatorComponent } from '@connect-services/src/lib/components/paginator/paginator.component';
import { FieldInterventionControllerGet200Response } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';
import { defaultPaginationParameters, OrderEnum, PaginationParameters } from '@shared/client/models/pagination.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CheckboxComponent, LoadingComponent, ManagementListHeaderComponent, PaginatorComponent, RessourcesModule],
    selector: 'app-notification-field-intervention-select',
    standalone: true,
    templateUrl: './notification-field-intervention-select.component.html',
})
export class NotificationFieldInterventionSelectComponent extends AbstractNotificationSelectListComponent<
    FieldInterventionListBloc,
    FieldInterventionControllerGet200Response
> {
    public override paginationParameters: PaginationParameters = {
        ...defaultPaginationParameters,
        order: OrderEnum.ASC,
        orderBy: 'name',
        take: 9,
    };

    protected readonly bloc = inject(FieldInterventionListBloc);

    private readonly projectService = inject(ProjectService);

    protected getProjectNameById(projectId: string): string {
        return (this.projectService.projects() ?? []).find((project) => project.id === projectId)?.name ?? '';
    }
}
